import { render, staticRenderFns } from "./VipToast.vue?vue&type=template&id=f402b29c&scoped=true&"
import script from "./VipToast.vue?vue&type=script&lang=ts&"
export * from "./VipToast.vue?vue&type=script&lang=ts&"
import style0 from "./VipToast.scss?vue&type=style&index=0&id=f402b29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f402b29c",
  null
  
)

export default component.exports